// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kedy","content":"styles_content__1ocFe"};